import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className='footer'>
            <p>Copyright © 2021 Online-Courses.com</p>
        </div>
    );
};

export default Footer;